import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerAnagraficaInTdocModalComponent} from './worker-anagrafica-in-tdoc-modal';

export const WorkerAnagraficaInTdocModalModule: string = ng
    .module('worker-anagrafica-in-tdoc-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerAnagraficaInTdocModalComponent', WorkerAnagraficaInTdocModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/anagrafica-in-tdoc/worker-anagrafica-in-tdoc-modal/worker-anagrafica-in-tdoc-modal.module.ts